import React, { Component } from 'react';

class ColorFilter extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { item, group, searchFacetChange } = this.props;
        const isSelected =
            group.selectedOptions !== null &&
            group.selectedOptions.includes(item.id);
        const extraFields = item.productItem;
        const isEnabled = item.quantity > 0 || group.selectedOptions.includes(item.id);

        if (extraFields) {
            const hexCodes = extraFields.colorHexCode.trim().split(',');

            return (
                <div className="faceted-filter-outer">
                    <label
                        title={item.productItem.colorDisplayName}
                        className={`faceted-filter ${
                            isSelected ? 'faceted-filter--selected-color' : ''
                        }`}
                    >
                        <div className="faceted-filter-input-wrapper faceted-filter-input-wrapper--colors">
                            <input
                                className="faceted-filter__input"
                                type="checkbox"
                                onChange={event =>
                                    !isSelected
                                        ? searchFacetChange(group, item)
                                        : event.stopPropagation()
                                }
                                checked={isSelected}
                                disabled={!isEnabled}
                            />
                            <div className="color-icon-outer">
                                {isEnabled ? 
                                    <div
                                        className={`color-icon-border ${
                                            isSelected
                                                ? `color-icon-border--selected`
                                                : ''
                                        }`}
                                    >
                                        <div className="color-icon-wrapper">
                                            {hexCodes &&
                                                hexCodes.map(color => 
                                                    <div
                                                        key={[color]}
                                                        className="color-icon"
                                                        style={{
                                                            backgroundColor: color,
                                                        }}
                                                    ></div>
                                                )}
                                        </div>
                                    </div>
                                 : 
                                    <div
                                        className={
                                            'color-icon-border color-icon-border--disabled'
                                        }
                                    >
                                        <div className="color-icon-wrapper">
                                            {hexCodes &&
                                                hexCodes.map(color => 
                                                    <div
                                                        key={[color]}
                                                        className="color-icon"
                                                        style={{
                                                            backgroundColor: color,
                                                        }}
                                                    ></div>
                                                )}
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </label>
                </div>
            );
        } else {
            return (
                <div className="faceted-filter faceted-filter-error">
                    <strong>Unable to read: {item.id}</strong>
                </div>
            );
        }
    }
}

export default ColorFilter;
